import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=3cad7375&"
import script from "./MainContent.vue?vue&type=script&lang=js&"
export * from "./MainContent.vue?vue&type=script&lang=js&"
import style0 from "./MainContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports